<template lang="html">
  <div class="post-card" @click="commentLog(flagLog, index)">
    <div class="post-user">
      <div class="avatar">
        <!-- <a :href="`${$$hostname('shequ')}/dynamic/feed/user/${comment.user.uid}?cmd=usercard&userid=${comment.user.uid}&userType=${comment.user.type}`"> -->
        <img :src="experience.full_photo | avatar(90, 90)" alt="" />
        <!-- </a> -->
      </div>
      <div class="user-name">
        <p>
          {{ name(experience.nickname) }}
          <!-- <a :href="`${$$hostname('shequ')}/dynamic/feed/user/${comment.user.uid}?cmd=usercard&userid=${comment.user.uid}&userType=${comment.user.type}`">{{name(comment.user.nickname)}}</a> -->
        </p>
        <time>{{ timeFormat(experience.time_stamp * 1000) }}</time>
      </div>
    </div>
    <div class="post-main">
      <div class="post-content" :class="{ 'ommit-content': ommitContent }">
        {{ experience.content }}
      </div>
      <div
        class="post-imgs"
        v-if="experience.pic_lists && experience.pic_lists.length > 0"
      >
        <ul>
          <li
            v-for="(image, index) in pics"
            @click="showImage(imgLog, pics, index)"
          >
            <img v-lazy="$$viewImageInCenter(image.pic, 203, 203)" alt="" />
          </li>
        </ul>
      </div>
      <div class="zan-love">
        <div class="quanzi">
          <i class="iconfont icon-quanzi"></i>{{ quanzi }}
        </div>
        <div class="zan">
          <span><i class="iconfont icon-zan"></i>{{ experience.dig_num }}</span>
          <span
            ><i class="iconfont icon-huifu"></i
            >{{ experience.comment_num }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    experience: {
      type: Object,
      default() {
        return {}
      }
    },
    ommitContent: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: null
    },
    flagLog: {
      type: Boolean,
      default: false
    },
    imgLog: {
      type: Boolean,
      default: false
    },
    source: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {
    user(obj) {
      let schedualAreas = []
      if (obj.service.length > 0) {
        schedualAreas = obj.service.map(ele => ({
          districtName: ele
        }))
      }
      return {
        is_del: obj.is_del,
        headPicUrl: obj.photo,
        uid: obj.uid,
        name: obj.name,
        score: obj.score,
        schedualAreas
      }
    },
    name(val) {
      if (!val) {
        return '用户'
      }
      if (val.length > 1) {
        return `${val.charAt(0)}***${val.charAt(val.length - 1)}`
      } else if (val.length === 1) {
        return `${val.charAt(0)}***`
      } else {
        return `用户${this.experience.uid}`
      }
    },
    getUserID(user) {
      if (user.is_del === 0 || !user.uid) {
        // 离职
        return
      }
      this.$$tracker('100101', '20000', 21030)
      location.href = `/v/user/${user.uid}`
    },
    showImage(imgLog, images, index) {
      if (imgLog) {
        this.$$tracker('140101', '20000', '21128')
      }
      const image_list = images.map(ele => ele.pic)
      // this.$store.commit('setPreviewImages', image_list)
      // this.$router.push({ query: { preview: true, index } })
    },
    timeFormat(time) {
      const now = new Date()
      const now_y = now.getFullYear()
      const date = new Date(time)
      const date_y = date.getFullYear()
      if (now_y === date_y) {
        return this.$$dateFormat(time, 'MM.DD hh:mm')
      } else {
        return this.$$dateFormat(time, 'YY.MM.DD hh:mm')
      }
    },
    commentLog(flagLog, key) {
      if (flagLog) {
        const index = key + 1
        this.$$tracker('140301', '20000', '21192')
      }
      location.href = `${this.$$hostname('shequ')}/dynamic/post/detail/${
        this.experience.feed_id
      }??cmd=sqtopicDetail&feedId=${this.experience.feed_id}&feedType=${
        this.experience.feed_type
      }`
    }
  },
  computed: {
    quanzi() {
      if (this.experience.column_tag) {
        const names = this.experience.column_tag.map(ele => ele.name)
        return names.join(',')
      }
      return ''
    },
    pics() {
      if (this.experience.pic_lists && this.experience.pic_lists.length > 0) {
        console.log(this.experience.pic_lists.length)
        return this.experience.pic_lists.length > 3
          ? this.experience.pic_lists.slice(0, 3)
          : this.experience.pic_lists
      }
      return []
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.post-card {
  padding: rem(15px) rem(20px);
  font-size: rem(28px);
  background: #fff;
  @include border(bottom);
  overflow: hidden;

  &::after {
    left: rem(20px);
    right: rem(20px);
  }
  &:last-of-type {
    &::after {
      display: none;
    }
  }
  .post-user {
    display: flex;
    align-items: center;
  }
  .avatar {
    width: rem(60px);
    height: rem(60px);
    margin-right: rem(20px);
    border-radius: 50%;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .post-main {
    padding-bottom: rem(15px);
  }
  .user-name {
    display: flex;
    flex: 1;
    color: #666;
    line-height: rem(60px);
    align-items: center;
    > p {
      flex: 1;
    }
    time {
      color: #999;
      font-size: rem(24px);
    }
  }
  .post-content {
    margin-top: rem(20px);
    word-break: break-all;
    line-height: 1.3;
    .dot {
      color: #fe3a7f;
    }
  }
  .ommit-content {
    display: -webkit-box;
    word-break: break-all;
    text-align: left;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    max-height: 4.5em;
    overflow: hidden;
  }
  .post-imgs {
    margin-top: rem(28px);

    ul {
      display: flex;
      height: rem(203px);
      overflow: hidden;
    }

    li {
      position: relative;
      width: 33.3333%;
      height: rem(203px);
      margin-right: rem(20px);

      img {
        max-width: 100%;
        // max-height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        // width: 100%;
        // height: 100%;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
  .zan-love {
    display: flex;
    align-items: center;
    margin-top: rem(20px);
    font-size: rem(24px);
    color: #999;

    .quanzi {
      flex: 1;
    }
    .zan {
      span {
        margin-left: rem(20px);
      }
    }
    .iconfont {
      font-size: rem(24px);
      margin-right: rem(10px);
      vertical-align: middle;
    }
    .icon-quanzi,
    .icon-zan {
      color: #ff397e;
    }
  }
}
</style>
